import { Directive } from '@angular/core';
import { BrnPopoverContent } from '@spartan-ng/brain/popover';

/**
 * Structural directive that acts as the portal for popover content.
 * Applied as `*hlmPopoverPortal` on the `<hlm-popover-content>` element.
 *
 * Extends `BrnPopoverContent` which registers the template with the parent
 * BrnPopover and opens it in a CDK overlay when triggered.
 *
 * @example
 * <hlm-popover-content *hlmPopoverPortal>...</hlm-popover-content>
 */
@Directive({
  selector: '[hlmPopoverPortal]',
  standalone: true,
  hostDirectives: [BrnPopoverContent],
})
export class HlmPopoverPortalDirective {}
